import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class PagoService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    validarFoliosEnLiquidacion(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($empresa_rut: Decimal, $cliente_proveedor_rut: Decimal, $documentos: [pagoDocInputType]) {
            pago {
              validarFoliosEnLiquidacion(entidad: { empresa_rut: $empresa_rut, cliente_proveedor_rut: $cliente_proveedor_rut, documentos: $documentos }) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  no_existen_folios
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            callback({
                respuesta: response.data.pago.validarFoliosEnLiquidacion.respuesta,
                mensajes: response.data.pago.validarFoliosEnLiquidacion.mensajes,
            });
        });
    }
    conformeAbono(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: pagoDTOInputType) {
            pago {
              conformeAbono(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  saldoDocumento {
                    codigo
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    monto
                    saldo
                    pagado
                    cliente_proveedor_rut
                    sucursal_codigo
                    pago
                    abono
                    deuda
                  }
                  difereciaPago {
                    codigo
                    pago_codigo
                    saldo
                    activado
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    cliente_proveedor_rut
                    sucursal_codigo
                    fecha_doc
                    tipo_pago_cuenta_nombre
                    tipo_pago_cuenta_codigo
                    referencia_documento
                    monto
                    pago_cuenta_utilizado
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pago.conformeAbono;
            callback({ mensajes, respuesta });
        });
    }
    agregarFormaPago(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: pagoDTOInputType) {
            pago {
              agregarFormaPago(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  forma_pago {
                    tipo_pago_codigo
                    empresa_rut
                    tipo_cuenta_bancaria_codigo
                    banco_codigo
                    banco_nombre
                    numero_cuenta
                    fecha_pago
                    monto
                    sucursal_codigo
                    numero_doc
                    tipo_pago_nombre
                    excedente
                  }
                  total_forma_pago
                  diferencial_pago
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pago.agregarFormaPago;
            callback({ mensajes, respuesta });
        });
    }
    obtenerTotalDiferencialUtilizado(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: pagoDTOInputType) {
            diferencia_pago {
              obtenerTotalDiferencialUtilizado(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  total_pago_cuenta
                  total_pago_cuenta_utilizado
                  diferencial_pagar
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.diferencia_pago.obtenerTotalDiferencialUtilizado;
            callback({ mensajes, respuesta });
        });
    }
    obtenerPagoAcuenta(rut_emisor, sucursal_codigo, cliente_proveedor_rut, activado, callback) {
        const inputParams = {
            entidad: {
                rut_emisor,
                sucursal_codigo,
                cliente_proveedor_rut,
                activado,
            },
        };
        this.gqlclient.query({
            query: gql `
          query ($entidad: diferencia_pagoInputType) {
            diferencia_pago {
              obtenerPagoAcuenta(entidad: $entidad) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    codigo
                    pago_codigo
                    monto
                    saldo
                    activado
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    cliente_proveedor_rut
                    sucursal_codigo
                    fecha_doc
                    referencia_documento
                    tipo_pago_cuenta_nombre
                    tipo_pago_cuenta_codigo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.diferencia_pago.obtenerPagoAcuenta;
            callback({ mensajes, respuesta });
        });
    }
    obtenerTotalConformeProveedor(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: pagoDTOInputType) {
          diferencia_pago {
            obtenerTotalConformeProveedor(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                total_pago_cuenta
                total_pago_cuenta_utilizado
                diferencial_pagar
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, (res) => {
            const data = res.data.diferencia_pago.obtenerTotalConformeProveedor;
            const { mensajes, respuesta } = data;
            callback({ mensajes, respuesta });
        });
    }
    // Cta. Cte. Realizar pagos
    guardarPagos(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          mutation ($entidad: declaracionDTOInputType) {
            pago {
              guardarPagos(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  declaracionControl {
                    codigo
                    empresa_rut
                    sucursal_codigo
                    vendedor_codigo
                    chofer_rut
                    cliente_proveedor_rut
                    otro
                    fecha_declaracion
                  }
                  pagos {
                    forma_pago {
                      codigo
                    }
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pago.guardarPagos;
            callback({ mensajes, respuesta });
        });
    }
    // Liquidación de recorrido
    ControlDeEfectivoLiqRecorrido(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          mutation ($entidad: declaracionControlEfectivoInputType) {
            liquidacion_recorrido {
              controlDeEfectivo(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  recorrido {
                    codigo
                  }
                }
              }
            }
          }
        `,
            variables: {
                entidad: inputParams,
            },
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.liquidacion_recorrido.controlDeEfectivo;
            callback({ mensajes, respuesta });
        });
    }
    validaDeclaracion(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: declaracionDTOInputType, $addPago: pagoDTOInputType) {
            pago {
              validaDeclaracion(entidad: $entidad, addPago: $addPago) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  declaracionControl {
                    empresa_rut
                    sucursal_codigo
                    vendedor_codigo
                    chofer_rut
                    cliente_proveedor_rut
                    otro
                    fecha_declaracion
                    observaciones
                  }
                  pagos {
                    saldoDocumento {
                      codigo
                      rut_emisor
                      folio
                      tipo_dte_codigo
                      cliente_proveedor_rut
                      monto
                      saldo
                      abono
                      pagado
                      ref_doc
                      tipo_pago
                      reversa_pago_codigo
                      protesto_cheque_codigo
                      vendedor_codigo
                      vendedor_nombre
                      recorrido_codigo
                      recorrido_estado
                      sucursal_codigo
                      seleccion
                    }
                    difereciaPago {
                      codigo
                      monto
                      saldo
                      activado
                      rut_emisor
                      folio
                      tipo_dte_codigo
                      cliente_proveedor_rut
                      sucursal_codigo
                      fecha_doc
                      referencia_documento
                      tipo_pago_cuenta_nombre
                      tipo_pago_cuenta_codigo
                      seleccion
                      pago_cuenta_utilizado
                    }
                    forma_pago {
                      tipo_pago_codigo
                      empresa_rut
                      tipo_cuenta_bancaria_codigo
                      banco_codigo
                      banco_nombre
                      numero_cuenta
                      fecha_pago
                      monto
                      sucursal_codigo
                      numero_doc
                      tipo_pago_nombre
                    }
                    monto_coforme
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pago.validaDeclaracion;
            callback({ mensajes, respuesta });
        });
    }
    obtenerPagosRealizados(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: pagoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            pago {
              obtenerPagosRealizados(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    movimiento_pago_codigo
                    documento
                    referencia_documento
                    fecha_pago
                    fecha_vencimiento
                    monto
                    cliente_proveedor_rut
                    empresa_rut
                    sucursal_codigo
                    vendedor_codigo
                    es_liquidacion
                    puede_reversar
                    motivo_bloqueo_reverso
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pago.obtenerPagosRealizados;
            callback({ mensajes, respuesta });
        });
    }
    obtenerPagosRealizadosPorFecha(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: pagoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            pago {
              obtenerPagosRealizadosPorFecha(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    movimiento_pago_codigo
                    documento
                    referencia_documento
                    fecha_pago
                    fecha_vencimiento
                    monto
                    cliente_proveedor_rut
                    empresa_rut
                    sucursal_codigo
                    es_liquidacion
                    puede_reversar
                    motivo_bloqueo_reverso
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pago.obtenerPagosRealizadosPorFecha;
            callback({ mensajes, respuesta });
        });
    }
    obtenerChequeIngresados(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: pagoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            pago {
              obtenerChequeIngresados(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    numero_doc
                    fecha_pago
                    monto
                    fecha_vencimiento
                    cliente_proveedor_rut
                    empresa_rut
                    sucursal_codigo
                    cliente_proveedor_nombre
                    numero_cuenta
                    banco_codigo
                    banco_nombre
                    tipo_pago_codigo
                    control_resumido_codigo
                    pagado
                    tipo_cuenta_bancaria_codigo
                    estado_codigo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pago.obtenerChequeIngresados;
            callback({ mensajes, respuesta });
        });
    }
    obtenerChequeIngresadosSegunCodigo(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: pagoInputType) {
            pago {
              obtenerChequeIngresadosSegunCodigo(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  codigo
                  numero_doc
                  fecha_pago
                  monto
                  fecha_vencimiento
                  cliente_proveedor_rut
                  empresa_rut
                  sucursal_codigo
                  cliente_proveedor_nombre
                  numero_cuenta
                  banco_codigo
                  banco_nombre
                  tipo_pago_codigo
                  control_resumido_codigo
                  pagado
                  tipo_cuenta_bancaria_codigo
                  observacion
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pago.obtenerChequeIngresadosSegunCodigo;
            callback({ mensajes, respuesta });
        });
    }
    cambiarFechaVencimiento(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          mutation ($entidad: pagoInputType) {
            pago {
              cambioFechaVencCheque(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  codigo
                  numero_doc
                  fecha_pago
                  monto
                  fecha_vencimiento
                  cliente_proveedor_rut
                  empresa_rut
                  sucursal_codigo
                  cliente_proveedor_nombre
                  numero_cuenta
                  banco_codigo
                  banco_nombre
                  tipo_pago_codigo
                  control_resumido_codigo
                  pagado
                  tipo_cuenta_bancaria_codigo
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pago.cambioFechaVencCheque;
            callback({ mensajes, respuesta });
        });
    }
    obtenerChequeDeposito(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: pagoInputType, $tipo_busquedad: Boolean, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            pago {
              obtenerChequeDeposito(entidad: $entidad, tipo_busquedad: $tipo_busquedad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    numero_doc
                    fecha_pago
                    monto
                    fecha_vencimiento
                    cliente_proveedor_rut
                    empresa_rut
                    sucursal_codigo
                    cliente_proveedor_nombre
                    numero_cuenta
                    banco_codigo
                    banco_nombre
                    tipo_pago_codigo
                    control_resumido_codigo
                    pagado
                    tipo_cuenta_bancaria_codigo
                    estado_codigo
                    estado_nombre
                    origen
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pago.obtenerChequeDeposito;
            callback({ mensajes, respuesta });
        });
    }
    obtenerChequeDepositoExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: pagoInputType, $tipo_busquedad: Boolean, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            pago {
              obtenerChequeDeposito(entidad: $entidad, tipo_busquedad: $tipo_busquedad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pago.obtenerChequeDeposito;
            callback({ mensajes, respuesta });
        });
    }
    obtenerPagosParaConsulta(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: pagoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            pago {
              obtenerPagosParaConsulta(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    empresa_rut
                    sucursal_codigo
                    fecha_pago
                    cliente_proveedor_rut
                    cliente_proveedor_nombre
                    origen
                    monto
                    monto_abonado
                    rut_recaudador
                    nombre_recaudador
                    folio
                    recorrido_codigo
                    fecha_emision
                    fecha_pago
                    codigo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pago.obtenerPagosParaConsulta;
            callback({ mensajes, respuesta });
        });
    }
    obtenerPagosParaConsultaExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: pagoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            pago {
              obtenerPagosParaConsulta(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pago.obtenerPagosParaConsulta;
            callback({ mensajes, respuesta });
        });
    }
    obtenerPagoEspecifico(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: pagoInputType) {
            pago {
              obtenerPagoEspecifico(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  rut_recaudador
                  nombre_recaudador
                  saldoDocumento {
                    codigo
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    sucursal_codigo
                    tipo_pago
                    ref_doc
                    vendedor_codigo
                    vendedor_nombre
                    fecha_emision
                    fechaVencimientoDocto
                    monto
                    pago
                    saldo
                  }
                  difereciaPago {
                    codigo
                    fecha_doc
                    folio
                    monto
                    pago_codigo
                    referencia_documento
                    rut_emisor
                    saldo
                    sucursal_codigo
                    tipo_dte_codigo
                    tipo_pago_cuenta_codigo
                    tipo_pago_cuenta_nombre
                  }
                  forma_pago {
                    codigo
                    empresa_rut
                    sucursal_codigo
                    tipo_pago_codigo
                    tipo_pago_nombre
                    banco_codigo
                    banco_nombre
                    fecha_vencimiento
                    fecha_pago
                    tipo_cuenta_bancaria_codigo
                    numero_cuenta
                    numero_doc
                    fecha_vencDep
                    monto
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pago.obtenerPagoEspecifico;
            callback({ mensajes, respuesta });
        });
    }
    obtenerPagoEspecificoPDF(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: pagoInputType) {
            pago {
              obtenerPagoEspecifico(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  rutaArchivo
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pago.obtenerPagoEspecifico;
            callback({ mensajes, respuesta });
        });
    }
    obtenerPagosParaConsultaProveedor(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: pagoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            pago {
              obtenerPagosParaConsultaProveedor(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    empresa_rut
                    sucursal_codigo
                    fecha_pago
                    codigo
                    cliente_proveedor_rut
                    cliente_proveedor_nombre
                    origen
                    monto
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pago.obtenerPagosParaConsultaProveedor;
            callback({ mensajes, respuesta });
        });
    }
    obtenerPagosParaConsultaProveedorExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: pagoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            pago {
              obtenerPagosParaConsulta(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pago.obtenerPagosParaConsulta;
            callback({ mensajes, respuesta });
        });
    }
    obtenerPagoProveedorEspecifico(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: pagoInputType) {
            pago {
              obtenerPagoEspecificoProveedor(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  saldoDocumento {
                    codigo
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    sucursal_codigo
                    tipo_pago
                    ref_doc
                    vendedor_codigo
                    vendedor_nombre
                    fecha_emision
                    monto
                    pago
                    saldo
                  }
                  canjeDocumento {
                    codigo
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    sucursal_codigo
                    tipo_pago
                    ref_doc
                    vendedor_codigo
                    vendedor_nombre
                    fecha_emision
                    monto
                    pago
                    saldo
                  }
                  forma_pago {
                    codigo
                    empresa_rut
                    sucursal_codigo
                    tipo_pago_codigo
                    tipo_pago_nombre
                    banco_codigo
                    banco_nombre
                    tipo_cuenta_bancaria_codigo
                    numero_cuenta
                    numero_doc
                    monto
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pago.obtenerPagoEspecificoProveedor;
            callback({ mensajes, respuesta });
        });
    }
}
PagoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PagoService_Factory() { return new PagoService(i0.ɵɵinject(i1.GraphQLClient)); }, token: PagoService, providedIn: "root" });
